<template>
    <div class="comment_dialog" v-show="commentdata.show">
        <div class="cont">
            <p class="title">评论 <i class="iconfont" @click="cancleComment">&#xe67a;</i></p>
            <span class="replay_name" v-if="commentdata.reversionName == ''?false:true">回复【{{commentdata.reversionName}}】：</span>
            <textarea class="input_text" placeholder="请输入评论内容，最多输入500字符" v-model="commentReplayText" maxlength="500"></textarea>
            <div class="btn_box">
                <button @click="cancleComment">取消</button>
                <button class="hold" @click="submitComment">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        circleCommentRelay
    } from '@/utils/api-im.js'
    export default {
        data(){
            return {
                commentDialog: false, //评论弹窗
                commentReplayText: '', //评论和回复的内容
            }
        },
        props:{
            commentdata:{}
        },
        methods:{
            cancleComment(){
                this.$emit('closecomment')
            },
            submitComment(){
                let _this = this;
                let postData = {};
                if (this.commentdata.isReplay) {
                    postData = {
                        informationId: this.commentdata.informationId,
                        content: this.commentReplayText,
                        replyCommentId: this.commentdata.replayNum,
                    };
                } else {
                    postData = {
                        informationId: this.commentdata.informationId,
                        content: this.commentReplayText,
                    };
                }
                this.$post(circleCommentRelay, postData).then((res) => {
                    if (res.data.code == 200) {
                        this.$emit('closecomment')
                        this.commentReplayText = '';
                        // this.refreshTimer=setTimeout(function () {
                        //     _this.getCurrentCircleCont(_this.ajaxData);
                        // },2000)
                        _this.$toast("回复消息已提交，稍后刷新查看")
                    } else {
                        this.$toast(res.data.msg)
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    /*导入公用样式变量*/
    @import "../../../assets/css/publicVariable";
    /*评论弹窗*/
    .comment_dialog {
        width: 100%;
        height: 100%;
        overflow: auto;
        .displayFlex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .positionFix(@p: fixed;
        @t: 0;
        @l: 0;
        @bg: rgba(0, 0, 0, 0.5);
        @z: 2;
        );

        .cont {
            width: 600px;
            padding: 0 30px 30px;
            background: #fff;
            .borderRadius(8px);

            .title {
                line-height: 70px;
                font-size: 18px;
                color: #2A2A2A;
                position: relative;

                i {
                    color: #93999F;
                    font-size: 18px;
                    cursor: pointer;
                    .positionFix(@p: absolute;
                    @r: 0;
                    @t: 0;
                    );
                }
            }

            .replay_name {
                display: block;
                line-height: 20px;
                color: #2A2A2A;
                font-size: 14px;
                margin-bottom: 12px;
            }

            .input_text {
                width: 100%;
                height: 220px;
                box-sizing: border-box;
                border: 1px solid #DADEE0;
                padding: 12px 8px;
                resize: none;
                outline: none;
                .borderRadius(2px);
            }

            .btn_box {
                text-align: right;
                margin-top: 60px;

                button {
                    width: 60px;
                    height: 32px;
                    box-sizing: border-box;
                    display: inline-block;
                    border: 1px solid #DADEE0;
                    font-size: 14px;
                    color: #93999F;
                    cursor: pointer;
                    .borderRadius(2px);

                    &.hold {
                        border: 1px solid #0099ff;
                        background: #0099ff;
                        color: #fff;
                        margin-left: 8px;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/wechatMoments/components/comment.vue